// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eafOYIu_Ow4eWiMkplFy{align-items:center;gap:4px;min-width:0;display:flex;overflow:hidden}.OfgIMahAhMAjxHuGTLjJ{flex-shrink:0}.zYCELXvyw0I_tBpRzUlf{min-width:0;color:var(--content-primary-secondary)}.pGT4icgDJgszY7vO7xI_{color:var(--content-negative-primary)}.izxFyQFRwBIcSI6p9CoM{color:var(--content-primary-secondary);flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `eafOYIu_Ow4eWiMkplFy`,
	"icon": `OfgIMahAhMAjxHuGTLjJ`,
	"label": `zYCELXvyw0I_tBpRzUlf`,
	"labelDestructive": `pGT4icgDJgszY7vO7xI_`,
	"duration": `izxFyQFRwBIcSI6p9CoM`
};
export default ___CSS_LOADER_EXPORT___;
